export class SearchStatus {

    public hasResults: boolean = false;

    public recordCount: number = 0;

    public message: string;
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/shared/search/models/search-status.model.ts